import React from "react";
import { Route, Switch } from "react-router-dom";
import { UserList } from "../user/UserList";
import { UserDetail } from "../user/UserDetail";
import { UserEdit } from "../user/UserEdit";
import { UserCreate } from "../user/UserCreate";
import { LoginPage } from "../authentication/LoginPage";
import { PrivateRoute } from "./PrivateRoute";
import { connect } from "react-redux";

function UserLayout(props) {
  return (
    <Switch>
      <PrivateRoute exact path="/users" component={UserList} />

      <PrivateRoute exact path="/user/add" component={UserCreate} />

      <PrivateRoute exact path="/user/:id" component={UserDetail} />

      <PrivateRoute exact path="/users/:id/edit" component={UserEdit} />

      <Route path="/users" component={LoginPage} />
      
    </Switch>
  );
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication,
  };
}

const connectedUserLayout = connect(mapStateToProps)(UserLayout);
export { connectedUserLayout as UserLayout };
